// extracted by mini-css-extract-plugin
export default {"container":"Icon_container__4-Lwc","secondIcon":"Icon_secondIcon__t7yho","loader":"Icon_loader__roP2v","rotation":"Icon_rotation__JLe+I"};